import { render, staticRenderFns } from "./VenueTrainingGeneral.vue?vue&type=template&id=64cc450e"
import script from "./VenueTrainingGeneral.vue?vue&type=script&lang=js"
export * from "./VenueTrainingGeneral.vue?vue&type=script&lang=js"
import style0 from "./VenueTrainingGeneral.vue?vue&type=style&index=0&id=64cc450e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports